const PATH = 'fe.components.measure.view.cycle.meta_data_multi_select';

const messages = {
  type: {
    key: `${PATH}.type`,
    defaultValue: '{{category}} Type'
  },
  primary: {
    key: `${PATH}.primary`,
    defaultValue: '{{choice}} primary'
  }
};

export default messages;
